// extracted by mini-css-extract-plugin
export default {"row":"item-list_row__z6b9+"};